/*
 * Authors: mariushirjanu
 * Created: 24/07/2023
 */
import { Component, Input } from '@angular/core';
import { CatalogStateService } from '../../catalog/catalog-state.service';

@Component({
  selector: 'part-not-available-popup',
  template: `
    <p>The Part {{ partNr }} is no longer in catalog.</p>
    <div>The Part <strong>will not be included in your order</strong> when you submit.</div>
    <br />
    <div>
      What can you do?
      <ul>
        <li><a href [uiSref]="catalogOverviewState">Check the catalog</a> for an alternative part.</li>
        <li>If you cannot find an alternative part in the catalog, you can raise a ticket with the catalog owner to ask for an alternative.</li>
      </ul>
    </div>`
})
export class PartNotAvailablePopupComponent {
  @Input() public partNr:string;
  public catalogOverviewState:string = this.catalogStateService.overviewState;

  constructor(
    private catalogStateService:CatalogStateService
  ) {
    /***/
  }
}